import { Skeleton } from "@/components/ui/skeleton";

// Layout skeleton shown while a simulator's content (/api/content) and billing
// entitlement are still loading. Mirrors the typical sim header + intro card so
// the page doesn't flash a bare spinner.
export function SimSkeleton() {
  return (
    <div className="min-h-screen bg-[#F4F7F9]" data-testid="sim-skeleton">
      <header className="border-b border-slate-200 bg-white/70 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-9 h-9 rounded-md bg-slate-200" />
            <div className="space-y-1.5">
              <Skeleton className="h-3.5 w-28 bg-slate-200" />
              <Skeleton className="h-2.5 w-40 bg-slate-200" />
            </div>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <Skeleton className="h-8 w-20 rounded-md bg-slate-200" />
            <Skeleton className="h-8 w-24 rounded-md bg-slate-200" />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
          <div className="flex flex-col items-center text-center">
            <Skeleton className="w-14 h-14 rounded-xl bg-slate-200" />
            <Skeleton className="h-8 w-64 mt-5 bg-slate-200" />
            <Skeleton className="h-4 w-full max-w-md mt-4 bg-slate-200" />
            <Skeleton className="h-4 w-3/4 max-w-md mt-2 bg-slate-200" />

            <div className="flex flex-wrap justify-center gap-2 mt-6">
              {[20, 16, 24, 18].map((w, i) => (
                <Skeleton key={i} className="h-5 rounded bg-slate-200" style={{ width: `${w * 4}px` }} />
              ))}
            </div>

            <Skeleton className="h-11 w-52 rounded-lg mt-8 bg-slate-200" />
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-slate-400 text-sm mt-6" data-testid="sim-skeleton-label">
          Loading simulator…
        </div>
      </main>
    </div>
  );
}
